import { z } from "zod";

import { PluginEntityType, PluginMessage } from "../../schemas/plugin";
import {
  PluginCampaignType_2023_08_20,
  PluginFindReplaceType,
} from "../../schemas/plugin/config/experiments";
import {
  WidgetConfigType,
  WidgetStyleConfig,
  WidgetTypeType,
} from "../../schemas/widgets";
import { DiscountDtoSchema } from "../discounts";
import { OfferProductDto } from "../offer-products";
import { OnsiteEditDtoSchema } from "../onsite-edits";
import { UserInterfaceDtoSchema } from "../user-interfaces";

import { DiscountLikeObject } from "./discounts";
import { ExperimentLikeObject } from "./experiments";
import { TrafficConfigDtoSchema } from "./traffic-configs";

export const CampaignDtoSchema = z.object({
  id: z.string().uuid().optional(),
  name: z.string(),
  description: z.string().nullable(),
  discount: DiscountDtoSchema.optional(),
  discountId: z.string().uuid().nullable(),
  requiresLink: z.boolean(),
  linkBaseUrl: z.string().nullable(),
  enabledAtTs: z.number().nullable(),
  disabledAtTs: z.number().nullable(),
  isArchived: z.boolean(),
  isPreview: z.boolean(),
  includeProducts: z.boolean().optional(),
  excludeProducts: z.boolean().optional(),
  functionSyncError: z.boolean().optional(),
  // isDeleted: z.boolean(),
  createdAtTs: z.number().optional(),
  trafficConfig: TrafficConfigDtoSchema.nullish(),
  findReplaces: OnsiteEditDtoSchema.array().optional(),
  campaignNamesInSameFunction: z.string().array().optional(),
  // lastUpdateTs: z.number()
});

export type CampaignDto = z.infer<typeof CampaignDtoSchema>;

export const CampaignWithIdSchema = CampaignDtoSchema.extend({
  id: z.string().uuid(),
  // discount: DiscountWithIdSchema.optional(),
  userInterfaces: UserInterfaceDtoSchema.array().optional(),
  createdAtTs: z.number(),
});

export type CampaignWithIdType = z.infer<typeof CampaignWithIdSchema>;

export const CampaignActionList = [
  "enableCampaign",
  "disableCampaign",
  "archiveCampaign",
  "saveCampaign",
] as const;
export type CampaignActionType = (typeof CampaignActionList)[number];

export interface CampaignLikeObject {
  id: string;
  name: string;
  type: PluginEntityType;
  description: string | null;
  discountId: string | null;
  discount: DiscountLikeObject | null;
  findReplaces: PluginFindReplaceType[] | undefined;
  requiresLink: boolean;
  linkBaseUrl: string | null;
  enabledAtTs: number | null;
  disabledAtTs: number | null;
  isArchived: boolean;
  isPreview: boolean;
  createdAtTs: number;
  userInterfaces: Map<string, any>;
  experiment?: ExperimentLikeObject;
  shortId: string;
  getWidget: <T>(widgetType: WidgetTypeType) => T | undefined;
  hasWidget: (widgetType: WidgetTypeType) => boolean;
  userIsEligible: (
    updateMessage: (
      id: string,
      message: PluginMessage,
      onlyIfUndefined?: boolean
    ) => void,
    isPreview?: boolean
  ) => boolean;
  toModel: (options?: {
    includeTestProducts?: boolean;
  }) => PluginCampaignType_2023_08_20;
  toTrackModel: () => PluginCampaignType_2023_08_20;
  hasGWPTier: () => boolean;
  findVariant: (variantId: string) => OfferProductDto | undefined;
  setExperience: (experiment: ExperimentLikeObject) => void;
  findProduct: (productId: string) => OfferProductDto | undefined;
  getMessageBoxBuildRequirements: () => { id: string } | null;
  getQuantityButtonsBuildRequirements: (variantId: string | null) => {
    discount: DiscountLikeObject;
  } | null;
  getProgressBarBuildRequirements: () => {
    discount: DiscountLikeObject;
  } | null;

  // initializeUserInterfaces: (userInterfaces: UserInterfaceDto[]) => void;
  // buildWidgetConfig: (
  //   widgetId: string,
  //   config?: WidgetConfigType<string, WidgetStyleConfig, object>
  // ) => WidgetDto | null;
}
